import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { propNumber, propStr, } from '../../../../../../helpers/custom-prop-types';
/**
 * アップロード進捗モーダルフッターのプログレスバー
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const SlideSearchUploadProgressModalFooter = (props) => {
    const { progress, text } = props;
    const progressStyle = useMemo(() => ({
        width: `${progress}%`,
    }), [progress]);
    return (_jsxs("div", Object.assign({ className: 'slide_search_upload_modal_footer' }, { children: [_jsx("div", Object.assign({ className: 'slide_search_upload_modal_footer_text' }, { children: text })), _jsx("div", Object.assign({ className: 'slide_search_upload_modal_footer_progress' }, { children: _jsx("div", Object.assign({ className: 'slide_search_upload_modal_footer_progress_bar', style: progressStyle }, { children: _jsx("div", { className: 'slide_search_upload_modal_footer_progress_bar_color' }) })) }))] })));
};
SlideSearchUploadProgressModalFooter.propTypes = {
    progress: propNumber().isRequired,
    text: propStr(),
};
SlideSearchUploadProgressModalFooter.defaultProps = {
    text: '',
};
export default SlideSearchUploadProgressModalFooter;
